const PREFIX = "COMBOS"
const COMBO_TYPES = {
  LOAD_ALL: `${PREFIX}/LOAD_ALL`,
  LOAD_CITIES_FROM_STATE: `${PREFIX}/LOAD_CITIES_FROM_STATE`
}

export default COMBO_TYPES
